import PropTypes from 'prop-types'
import classNames from 'classnames'
import BaseBreadcrumb from '../../breadcrumb'

const Breadcrumb = ({ course, ...attrs }) => {
  attrs.className = classNames(
    attrs.className,
    [
      'bg-white',
      'relative',
      'pb-20'
    ]
  )

  return <section {...attrs}>
    <div
      className={
        classNames([
          'relative',
          'container',
          'px-4'
        ])
      }>
      <BaseBreadcrumb
        items={[
          {
            text: 'Cursos',
            href: '/cursos/'
          },
          {
            text: course.title,
            href: `/cursos/${course.id}/${course.meta.slug}`
          }
        ]} />
    </div>
  </section>
}

Breadcrumb.propTypes = {
  course: PropTypes.object
}

export default Breadcrumb
